import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { ITableColumn, IPagingParams } from 'src/app/models/generic-datatable/generic-datatable.model';
import { MyCustomPaginatorIntl } from 'src/app/shared/providers/mat-paginator-intl';

@Component({
    selector: 'app-generic-server-side-table',
    templateUrl: './generic-server-side-table.component.html',
    styleUrls: ['./generic-server-side-table.component.scss'],
    providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }],
})
export class GenericServerSideTableComponent<T> implements OnInit {

    COLUMNA_ACCIONES = 'actions';

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    @Input() columns: ITableColumn[] = [];

    @Input() data: T[] = [];
    @Input() pageSize = 10;
    @Input() total = 0;
    @Input() pageIndex = 0;
    @Input() isFiltering = false;

    @Input() isLoading = false;

    @Input() showEditButton?: boolean;
    @Input() showDeleteButton?: boolean;
    @Input() customAction?: string;

    @Output() edit = new EventEmitter<T>();
    @Output() delete = new EventEmitter<T>();
    @Output() executeCustomAction = new EventEmitter<T>();
    @Output() pageChange = new EventEmitter<IPagingParams>();

    dataSource: MatTableDataSource<T> = new MatTableDataSource<T>();
    displayedColumns: string[] = [];

    ngOnInit(): void {
        this.displayedColumns = this.columns
            .filter(column => (column.visible ?? true) && column.attributeName)
            .map(column => column.attributeName);

        if (this.displayedColumns.length === 0) {
            throw new Error('No se han proporcionado columnas visibles para la tabla.');
        }

        if (this.showEditButton || this.showDeleteButton || this.customAction) {
            this.displayedColumns.push(this.COLUMNA_ACCIONES);
        }

        this.dataSource.data = this.data;
    }

    ngAfterViewInit(): void {
        this.paginator.page.subscribe(() => this.onPageChange());
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            this.dataSource.data = this.data;
            
            if (this.paginator) {
                this.paginator.pageIndex = this.pageIndex;                
            }

        }

        if (changes['isFiltering'] && this.isFiltering) {
            this.paginator.pageIndex = 0;
        }

    }

    onEdit(element: T): void {
        this.edit.emit(element);
    }

    onDelete(element: T): void {
        this.delete.emit(element);
    }

    onExecuteCustomAction(element: T): void {
        this.executeCustomAction.emit(element);
    }

    onPageChange(): void {
        this.pageChange.emit({
            page: this.paginator.pageIndex + 1,
            size: this.paginator.pageSize
        });
    }
}